import { getStrapiURL } from "./api";

export function getStrapiMedia(media) {
  if(!media) return null;
  if(!media.data && !media.attributes) return null;
  
  const { url } = media.data ? media.data.attributes : media.attributes;
  if(!url) return null;
  
  const imageUrl = url.startsWith("/") ? getStrapiURL(url) : url;
  return imageUrl;
}
